import React from 'react';
import { useTranslation } from 'react-i18next';
import { UQButton } from '@dev/uniq-ui';

const LanguageSwitcher: React.FC = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
  };

  return (
    <div style={{ display: 'flex', gap: '0.5rem' }}>
      <UQButton
        onClick={() => changeLanguage('de')}
        type={i18n.language === 'de' ? 'primary' : 'secondary'}
        size="small"

      >
        DE
      </UQButton>
      <UQButton
        onClick={() => changeLanguage('en')}
        type={i18n.language === 'en' ? 'primary' : 'secondary'}
        size="small"

      >
        EN
      </UQButton>
    </div>
  );
};

export default LanguageSwitcher;
